import React from "react";
import { motion } from "framer-motion";

export default function Hero({ isDark }) {
  return (
    <section
      id="home"
      className={`min-h-screen flex items-center ${
        isDark ? "bg-navy-900" : "bg-gray-50"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 py-20 w-full grid md:grid-cols-2 gap-16 items-center">
        {/* LEFT */}
        <div className="max-w-xl">
          <h1
            style={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontSize: "clamp(2.3rem, 4.5vw, 3.2rem)",
              lineHeight: "1.15",
              fontWeight: 500,
              color: isDark ? "white" : "#111827",
            }}
          >
            Building scalable{" "}
            <span style={{ color: "var(--gold)" }}>backend systems</span> with
            Java & Microservices
          </h1>

          <p
            className="mt-6"
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: "1rem",
              lineHeight: "1.7",
              color: isDark ? "#9ca3af" : "#6b7280",
            }}
          >
            Backend Engineer focused on distributed systems, event-driven
            architecture, and high-performance APIs using Java, Spring Boot, and
            Kafka.
          </p>

          {/* CTA */}
          <div className="mt-8 flex gap-4">
            <button
              onClick={() =>
                document
                  .querySelector("#projects")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className="px-6 py-3 rounded-full text-sm transition"
              style={{
                background: "var(--gold)",
                color: "#0a0e1a",
              }}
            >
              View Work
            </button>

            <button
              onClick={() =>
                document
                  .querySelector("#contact")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className={`px-6 py-3 rounded-full text-sm border ${
                isDark
                  ? "text-white border-gray-600 hover:border-gray-400"
                  : "text-gray-700 border-gray-300 hover:border-gray-500"
              }`}
            >
              Contact
            </button>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="flex justify-center">
          {/* CARD CONTAINER */}
          <div
            className="p-3 rounded-2xl"
            style={{
              background: isDark ? "#0f172a" : "#ffffff",
              border: isDark
                ? "1px solid rgba(255,255,255,0.08)"
                : "1px solid #e5e7eb",
              boxShadow: isDark
                ? "0 20px 40px rgba(0,0,0,0.4)"
                : "0 10px 30px rgba(0,0,0,0.08)",
            }}
          >
            <motion.img
              src="/profileOne.png"
              alt="Nitesh Shaw"
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              whileHover={{ scale: 1.02 }}
              className="w-64 h-64 md:w-72 md:h-72 object-cover object-[center_20%] rounded-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
